export function getList_patient(array) {
  // 遍历 array，提取每个元素的 medmstrId，存入新数组并返回
  const result = [];
  if (Array.isArray(array)) {
    array.forEach(item => {
      if (item && item.medmstrId !== undefined) {
        result.push(item.medmstrId);
      }
    });
  }
  return result;
}



